import type { ClipboardEvent } from 'react';

import { Autocomplete, Chip, TextField } from '@mui/material';

import { CollapseFilter } from '../collapse-filter';

type MultilineTextFilterProps = {
  title: string;
  placeholder: string;
  value: string[];
  onChange: (value: string[]) => void;
  disabled?: boolean;
};

const SEPARATORS = /[\n,]+/;

export const MultilineTextFilter = (props: MultilineTextFilterProps) => {
  const { title, placeholder, value, onChange, disabled } = props;

  const commitTags = (tags: string[]) => {
    const normalized = [
      ...new Set(
        tags
          .flatMap((tag) => tag.split(SEPARATORS))
          .map((tag) => tag.trim())
          .filter(Boolean),
      ),
    ];
    onChange(normalized);
  };

  const handlePaste = (event: ClipboardEvent<HTMLDivElement>) => {
    event.preventDefault();
    if (disabled) return;
    commitTags([...value, ...event.clipboardData.getData('text').split(SEPARATORS)]);
  };

  return (
    <CollapseFilter title={title}>
      <Autocomplete
        options={[]}
        freeSolo
        multiple
        autoSelect
        value={value}
        onChange={(_, next) => commitTags(next)}
        renderValue={(tags, getItemProps) =>
          tags.map((tag, index) => {
            const { key, ...itemProps } = getItemProps({ index });
            return <Chip key={key} variant="filled" label={tag} {...itemProps} />;
          })
        }
        renderInput={(params) => (
          <TextField
            {...params}
            onPaste={handlePaste}
            placeholder={value.length ? '' : placeholder}
            // Not Autocomplete `disabled` — it would also disable chip deletion
            inputProps={{ ...params.inputProps, readOnly: disabled }}
          />
        )}
      />
    </CollapseFilter>
  );
};
